import React from 'react';
import { useRequiredReviewsCheck } from '@/shared/hooks/useRequiredReviewsCheck';
import { Preloader } from '@/components';

interface TestimonialsWrapperProps {
  children: React.ReactNode;
}

export const TestimonialsWrapper: React.FC<TestimonialsWrapperProps> = ({ children }) => {
  const { isLoading } = useRequiredReviewsCheck();

  if (isLoading) {
    return <Preloader />;
  }

  // Показываем обычное содержимое, навигация на /testimonials происходит в хуке
  return <>{children}</>;
};
